var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSitemapSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-design",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.1,61.5H87V54.4a5.9,5.9,0,0,0-5.9-5.9H53.9v-6H61A3.5,3.5,0,0,0,64.5,39V17.7A3.5,3.5,0,0,0,61,14.2H39.7a3.5,3.5,0,0,0-3.5,3.5V39a3.5,3.5,0,0,0,3.5,3.5h7.1v6H19.6a5.9,5.9,0,0,0-5.9,5.9v7.1H6.6A3.5,3.5,0,0,0,3.1,65V86.3a3.5,3.5,0,0,0,3.5,3.5H27.9a3.5,3.5,0,0,0,3.5-3.5V65a3.4,3.4,0,0,0-3.5-3.5H20.8v-6h26v6H39.7A3.5,3.5,0,0,0,36.2,65V86.3a3.5,3.5,0,0,0,3.5,3.5H61a3.5,3.5,0,0,0,3.5-3.5V65A3.5,3.5,0,0,0,61,61.5H53.9v-6h26v6H72.8A3.4,3.4,0,0,0,69.3,65V86.3a3.5,3.5,0,0,0,3.5,3.5H94.1a3.5,3.5,0,0,0,3.5-3.5V65A3.5,3.5,0,0,0,94.1,61.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSitemapSolid);
export default __webpack_public_path__ + "static/media/sitemap-solid.64ebeb9e.svg";
export { ForwardRef as ReactComponent };